import React, { useState } from "react";
import VerificationStep from "./steps/VerificationStep";
import BusinessInfoStep from "./steps/BusinessInfoStep";
import OwnerDetailsStep from "./steps/OwnerDetailsStep";
import PlanSelectionStep from "./steps/PlanSelectionStep";
import { wizardSteps } from "./data/OnboardingData";
import "../../styles-v2/onboarding/v2-onboarding-wizard.css";

const GymOwnerOnboarding = ({ onComplete }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    email: "",
    phone: "",
    emailVerified: false,
    phoneVerified: false,
    gymName: "",
    registrationNumber: "",
    gstNumber: "",
    address: "",
    state: "",
    city: "",
    pincode: "",
    fullName: "",
    designation: "",
    alternateContact: "",
    emergencyContact: "",
    profilePhoto: null,
    selectedPlan: null,
  });

  const updateFormData = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const goToNext = () => {
    if (currentStep < 4) {
      setCurrentStep(currentStep + 1);
    } else {
      onComplete && onComplete();
    }
  };

  const goToPrevious = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const getProgress = () => {
    return (currentStep / wizardSteps.length) * 100;
  };

  return (
    <div className="v2-gym-onboarding">
      <div className="v2-gym-onboarding__progress">
        <div className="v2-gym-onboarding__progress-header">
          <span className="v2-gym-onboarding__step-text">
            Step {currentStep} of {wizardSteps.length}
          </span>
          <span className="v2-gym-onboarding__progress-text">
            {getProgress().toFixed(0)}% Complete
          </span>
        </div>
        <div className="v2-gym-onboarding__progress-bar">
          <div
            className="v2-gym-onboarding__progress-fill"
            style={{ width: `${getProgress()}%` }}
          />
        </div>
      </div>

      <div className="v2-gym-onboarding__tabs">
        {wizardSteps.map((step) => (
          <button
            key={step.id}
            className={`v2-gym-onboarding__tab ${step.id === currentStep ? "v2-gym-onboarding__tab--active" : ""
              } ${step.id < currentStep ? "v2-gym-onboarding__tab--completed" : ""}`}
            onClick={() => setCurrentStep(step.id)}
          >
            {step.label}
          </button>
        ))}
      </div>

      <div className="v2-gym-onboarding__content">
        {currentStep === 1 && (
          <VerificationStep
            formData={formData}
            updateFormData={updateFormData}
            onNext={goToNext}
            onBack={goToPrevious}
          />
        )}

        {currentStep === 2 && (
          <BusinessInfoStep
            formData={formData}
            updateFormData={updateFormData}
            onNext={goToNext}
            onBack={goToPrevious}
          />
        )}

        {currentStep === 3 && (
          <OwnerDetailsStep
            formData={formData}
            updateFormData={updateFormData}
            onNext={goToNext}
            onBack={goToPrevious}
          />
        )}

        {currentStep === 4 && (
          <PlanSelectionStep
            formData={formData}
            updateFormData={updateFormData}
            onNext={goToNext}
            onBack={goToPrevious}
          />
        )}
      </div>
    </div>
  );
};

export default GymOwnerOnboarding;
